// extracted by mini-css-extract-plugin
module.exports = {"popover":"popover_popover__GnZNk","open":"popover_open__lGiHE","trigger":"popover_trigger__1G2mZ","overlay":"popover_overlay__Cnse_","inner":"popover_inner__ZkbYb"};